import { render, staticRenderFns } from "./profile.component.vue?vue&type=template&id=eb2c8c78"
import script from "./profile.component.vue?vue&type=script&lang=js"
export * from "./profile.component.vue?vue&type=script&lang=js"
import style0 from "./profile.component.vue?vue&type=style&index=0&id=eb2c8c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports